import { NgModule } from '@angular/core';
import { Routes, RouterModule, PreloadAllModules } from '@angular/router';
import { LogoutComponent } from './pages/auth/pages/signup/logout/logout.component';
import { setIsNewFlow } from './pages/auth/guards/set-is-new-flow.guard';
import { OperationsComponent } from './pages/transactions/operations/operations.component';
import { QrcodeComponent } from './pages/public/pages/qrcode/qrcode.component';
import { QrReaderComponent } from './pages/auth/pages/whitelabel/miniapp/qr-reader/qr-reader.component';
import { PaymentConfirmComponent } from './pages/auth/pages/whitelabel/miniapp/payment-confirm/payment-confirm.component';
import { PaymentCreationComponent } from './pages/auth/pages/whitelabel/miniapp/payment-creation/payment-creation.component';
import { NotAllowComponent } from './pages/auth/pages/signup/not-allow/not-allow.component';

const routes: Routes = [
  {
    path: 'auth',
    loadChildren: () => import('./pages/auth/auth.module').then((m) => m.AuthModule),
    canActivate: [setIsNewFlow],
  },
  {
    path: 'onboarding',
    loadChildren: () => import('./pages/auth/auth.module').then((m) => m.AuthModule),
    canActivate: [setIsNewFlow],
  },
  {
    path: 'support',
    loadChildren: () => import('./pages/public/public.module').then((m) => m.PublicModule),
  },
  {
    path: 'logout',
    component: LogoutComponent,
  },
  {
    path: 'not-allow',
    component: NotAllowComponent,
  },
  {
    path: 'operation',
    component: OperationsComponent,
  },
  {
    path: 'payment',
    component: QrReaderComponent,
  },
  {
    path: 'payment-confirm',
    component: PaymentConfirmComponent,
  },
  {
    path: 'payment-creation',
    component: PaymentCreationComponent,
  },
  {
    path: 'qr',
    component: QrcodeComponent,
  },
  { path: '', redirectTo: '/support', pathMatch: 'full' },
  { path: '**', redirectTo: 'onboarding' },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      preloadingStrategy: PreloadAllModules,
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
